import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EmailSender from '../../api/EmailSender';

const ContactArea = () => {
  const [defaultMessage, setDefaultMessage] = useState("");
  const location = useLocation();
  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const city = params.get("city");
    if (city) {
      setDefaultMessage(` Hey, I'm interested in travel services for ${city}.`);
      setFormData(prev => ({...prev, message: defaultMessage}));
    }
  }, [location, defaultMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const success = await sendEmail(
      formData,
      "New Contact Form Submission from House of Polani"
    );

    if (success) {
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    }
  };

  return (
    <>
      <section id="contact_main_arae" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="section_heading_center">
                <h2>Contact with us</h2>
              </div>
            </div>
          </div>
          <div className="contact_main_form_area_two">
            <div className="row">
              <div className="col-lg-8">
                <div className="contact_left_top_heading">
                  <h2>
                    Do you have any query? Contact with us to get any any
                    support.
                  </h2>
                  <h3>Leave us a message</h3>
                  <p>
                  Don't hesitate to contact Polifly's dedicated support team. We're here to assist you every step of the way!
                  </p>
                </div>
                <div className="contact_form_two">
                  <form onSubmit={handleSubmit} id="contact_form_content">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="First name*"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Last name*"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control bg_input"
                            placeholder="Email address*"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control bg_input"
                            placeholder="Mobile number*"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="form-control bg_input"
                            rows="5"
                            placeholder="Message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        {succeeded && (
                          <div className="alert alert-success" role="alert" style={{backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", borderRadius: "4px", padding: "15px", marginBottom: "20px"}}>
                            <h4 className="alert-heading" style={{color: "#155724"}}>Thank You!</h4>
                            <p>
                              Thank you for your message. We'll get back to you shortly!
                            </p>
                          </div>
                        )}
                        {error && (
                          <div className="alert alert-danger" role="alert">
                            <p>{error}</p>
                          </div>
                        )}
                        <div className="form-group">
                          <button 
                            type="submit" 
                            className="btn btn_theme btn_md"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Sending..." : "Send message"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="contact_two_left_wrapper">
                  <h3>Contact details</h3>
                  <div className="contact_details_wrapper">
                    <div className="contact_detais_item">
                      <h4>Help line</h4>
                      <h3>
                        <a href="tel:+01-234-567-890">(021) 32410444</a>
                      </h3>
                    </div>
                    <div className="contact_detais_item">
                      <h4>Support mail</h4>
                      <h3>
                        <a href="mailto:support@domain.com">
                        info@houseofpolani.com.pk
                        </a>
                      </h3>
                    </div>
                    <div className="contact_detais_item">
                      <h4>Contact hour</h4>
                      <h3>Mon-Sun : 24 hours </h3>
                    </div>
                    <div className="contact_map_area">
                      <iframe
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1809.7087914988413!2d67.07213!3d24.883734!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33ec19226ae07%3A0xe813145a89f902f9!2s344%20Siraj%20ud-Daulah%20Rd%2C%20Bahadurabad%20Bahadur%20Yar%20Jang%20CHS%2C%20Karachi%2C%20Karachi%20City%2C%20Sindh%2079001%2C%20Pakistan!5e0!3m2!1sen!2sus!4v1736461415346!5m2!1sen!2sus"
                      ></iframe>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactArea;
